import { Component, forwardRef, Input } from '@angular/core'
import { AbstractValueAccessor } from '@mistergreen/shared/angular-directives/abstract-value-accessor'
import { FormControl, NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms'
import { LocaleService } from '../../../../../../framework/locale/services/locale.service'
import { ConfiguratorOptiongroupOptionComponent } from '../configurator-optiongroup-option/configurator-optiongroup-option.component'

let _uniqueIdCounter: number = 0

@Component({
    selector: 'mg-configurator-optiongroup',
    template: '<ng-content></ng-content>',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ConfiguratorOptiongroupComponent),
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => ConfiguratorOptiongroupComponent),
            multi: true,
        },
    ],
})
export class ConfiguratorOptiongroupComponent extends AbstractValueAccessor {
    @Input()
    public name: string = `configurator-color-component-${_uniqueIdCounter++}`

    private options: ConfiguratorOptiongroupOptionComponent[] = []

    private updateValidityTimer: NodeJS.Timer

    private historicValues: string[] = []

    constructor(private localeService: LocaleService) {
        super()
    }

    get locale(): string {
        return this.localeService.locale
    }

    validate(control: FormControl) {
        return control.value ? null : { option: 'No option selected' }
    }

    registerOnChange(fn: (_: any) => void): void {
        this.onChange = value => {
            if (value) {
                const valueIndex = this.historicValues.indexOf(value)
                if (valueIndex > -1) {
                    this.historicValues.splice(valueIndex, 1)
                }
                this.historicValues = [value, ...this.historicValues]
            }

            fn(value)
        }
    }

    registerOption(option) {
        if (this.options.indexOf(option) === -1) {
            this.options.push(option)
            this.updateValidity()
        }
    }

    unregisterOption(option) {
        this.options = this.options.filter(item => item !== option)
    }

    private updateValidity() {
        clearTimeout(this.updateValidityTimer)
        this.updateValidityTimer = setTimeout(() => {
            if (!this.options.find(({ value: rimsValue }) => rimsValue === this.value)) {
                const validHistoricValue = this.historicValues.find(
                    value => !!this.options.find(({ value: rimsValue }) => rimsValue === value)
                )
                this.value = validHistoricValue
                    ? validHistoricValue
                    : this.options.length
                    ? this.options[0].value
                    : this.value
                this.writeValue(this.value)
            }
        }, 2)
    }
}
